<template>
  <div class="__Login-Form">
    <form @submit.prevent="handleLogin">
      <CSection margin-bottom="2rem">
        <!-- MFA Login -->
        <template v-if="mfaRequired">
          <CInput
            name="mfaToken"
            ref="username-input"
            :label="$t('MFA token')"
            v-model="mfaToken"
            required
            no-required-icon
            class="mb-xs"
            @input="typeSomeKeys"
          />
        </template>

        <!-- Normal Login -->
        <template v-else>
          <CInput
            name="id"
            ref="username-input"
            :label="$t('Username')"
            v-model="id"
            required
            no-required-icon
            class="mb-xs"
            @input="typeSomeKeys"
          />

          <CInput
            name="password"
            ref="password-input"
            :label="$t('Password')"
            v-model="password"
            type="password"
            required
            no-required-icon
            class="mb-xs"
            @input="typeSomeKeys"
          />
          <!-- Flag condition for reset password -->
          <!-- v-if="this.$flag('0bdb5b9d-9b2f-4e6c-98e8-422fae369b8d')" -->
          <div class="__LoginForm-resetPassword" v-on:click="resetPassword">
            {{ $t('Reset password') }}
          </div>
        </template>

        <!-- DEV BOARD for Development -->
        <LoginDevBoard v-model="apiType" v-if="showDevBoard">
          <!-- TODO: Remove this from Login page. Move to other section -->
          <div class="__LoginForm-Port">
            <CTitle>
              Port
            </CTitle>
            <div class="content">
              <!--<div class="port-item">-->
              <!--  <div class="app-name">Wave</div>-->
              <!--  <input type="number" v-model="wavePort" />-->
              <!--</div>-->
              <div class="port-item">
                <div>RBAC</div>
                <input type="number" v-model="rbacPort" />
              </div>
              <div class="port-item">
                <div>Invoice</div>
                <input type="number" v-model="invoicePort" />
              </div>
              <div class="port-item">
                <div>Aqua</div>
                <input type="number" v-model="aquaPort" />
              </div>
            </div>
          </div>
        </LoginDevBoard>

        <Alert type="danger" v-if="isInvalid">
          {{ $t('Username or Password is invalid.') }}
        </Alert>
      </CSection>

      <CButton color="primary" type="submit" full-width :loading="loading">
        {{ $t('Login') }}
      </CButton>
    </form>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapActions } from 'vuex';
import Config from '@/config';
import { appEnv, locationPort } from '@/lib/navigator';

import Button from '@/components/uikit/Button';
import Badge from '@/components/uikit/Badge';
import Alert from '@/components/uikit/Alert';
import CInput from '@/components/uikit/CInput';
import CButton from '@/components/uikit/CButton';
import CTitle from '@/components/uikit/CTitle';
import CSection from '@/components/uikit/CSection';

import LoginDevBoard from '@/pages/Login/LoginDevBoard';

const messages = {
  en: {
    Login: 'Login',
    Username: 'Username',
    Password: 'Password',
    'MFA token': 'MFA token',
    'Please enter MFA token from your device.': 'Please enter MFA token from your device.',
    'Reset password': 'Reset password',
    'Username or Password is invalid.': 'Username or Password is invalid.',
  },
  ja: {
    Login: 'ログイン',
    Username: 'ユーザー名',
    Password: 'パスワード',
    'MFA token': '認証コード',
    'Please enter MFA token from your device.': '認証コードを入力してください。',
    'Reset password': 'パスワードをリセットする',
    'Username or Password is invalid.': 'ユーザー名もしくはパスワードが正しくありません。',
  },
};

export default {
  name: 'LoginForm',
  i18n: { messages },
  components: { Button, Badge, Alert, CInput, CButton, CSection, CTitle, LoginDevBoard },
  data: function() {
    return {
      loading: false,
      id: null,
      password: null,
      mfaToken: null,
      isInvalid: false,
      mfaRequired: false,

      appType: '',
      apiType: '',

      wavePort: null,
      rbacPort: null,
      invoicePort: null,
      aquaPort: null,
    };
  },
  created() {
    // Wave for Resellerのトークンを削除
    Cookies.remove('mo_wave_for_reseller_access_token', { path: Config.cookiePath });

    //const appType = Cookies.get('app_type');
    //this.appType = appType ? appType : Config.defaultAppEnv;

    this.appType = Config.defaultAppEnv;

    const apiType = Cookies.get('api_type');
    this.apiType = apiType ? apiType : Config.defaultApiEnv;

    const wavePort = Cookies.get('wave_port');
    if (wavePort) this.wavePort = wavePort;

    const rbacPort = Cookies.get('rbac_port');
    if (rbacPort) this.rbacPort = rbacPort;

    const invoicePort = Cookies.get('invoice_port');
    if (invoicePort) this.invoicePort = invoicePort;

    const aquaPort = Cookies.get('aqua_port');
    if (aquaPort) this.aquaPort = aquaPort;

    if (appEnv === 'localhost') {
      Cookies.set('wave_port', locationPort, { expires: Config.tokenExpire });
    }
  },
  mounted() {
    this.$refs['username-input'].focus();
  },
  watch: {
    id(value) {
      this.id = value.replace(/\s+/g, '');
    },
    password(value) {
      this.password = value.replace(/\s+/g, '');
    },
    mfaToken(value) {
      this.mfaToken = value.replace(/\s+/g, '');
    },
    appType(val) {
      Cookies.set('app_type', val, { expires: Config.tokenExpire });
    },
    apiType(val) {
      Cookies.set('api_type', val, { expires: Config.tokenExpire });
    },
    wavePort(val) {
      Cookies.set('wave_port', val, { expires: Config.tokenExpire });
    },
    rbacPort(val) {
      Cookies.set('rbac_port', val, { expires: Config.tokenExpire });
    },
    invoicePort(val) {
      Cookies.set('invoice_port', val, { expires: Config.tokenExpire });
    },
    aquaPort(val) {
      Cookies.set('aqua_port', val, { expires: Config.tokenExpire });
    },
  },
  computed: {
    appVersion() {
      return Config.version;
    },

    currentEnv() {
      return process.env.VUE_APP_MODE;
    },

    isLoading() {
      return this.$store.state.auth.loading;
    },

    showDevBoard() {
      return appEnv === 'localhost' || appEnv === 'dev';
    },

    maintenance() {
      return false;
      //return maintenanceTimer();
    },
  },
  methods: {
    async resetPassword() {
      await this.$router.push('/change-password').catch(() => {});
    },
    ...mapActions('auth', {
      getAccessToken: 'getAccessToken',
      setAccessToken: 'setAccessToken',
    }),

    async handleLogin() {
      this.loading = true;

      try {
        // Validate
        await this.$refs['username-input'].validate();
        if (!this.mfaRequired) await this.$refs['password-input'].validate();

        const params = {
          username: this.id,
          password: this.password,
          mfaToken: this.mfaToken,
          grantType: 'password',
        };

        //await this.validateForm();
        const token = await this.getAccessToken(params);
        await this.setTokenCookie(token);
        await this.$root.loadInitialData('login');
      } catch (e) {
        console.log(e);
        if (e.response) {
          if (e.response.data && e.response.data.error === 'mfa_token_required') {
            this.mfaRequired = true;
          } else {
            this.mfaToken = null;
            this.mfaRequired = false;
            this.isInvalid = true;
          }
        }
      } finally {
        this.loading = false;
      }
    },

    setTokenCookie(token) {
      Cookies.set('mo_access_token', token, {
        expires: Config.tokenExpire,
        path: Config.cookiePath,
      });

      return Promise.resolve();
    },

    async validateForm() {
      await this.$validator.validate();
    },

    typeSomeKeys() {
      this.isInvalid = false;
    },

    //handleChangeLang(value) {
    //  Cookies.set('mo-wave-locale', value, {
    //    expires: 300,
    //  });
    //  this.$i18n.locale = value;
    //  this.$validator.localize(value);
    //  localStorage.setItem('temporaryLanguage', value);
    //},
  },
};
</script>

<style lang="scss" scoped>
.__LoginForm {
  &-Port {
    margin-bottom: $space-md;

    .content {
      display: flex;
      justify-content: space-between;
    }

    input {
      width: 70px;
    }
  }
  &-resetPassword {
    cursor: pointer;
    margin-bottom: 5px;
    color: #1976d2;
  }
}
</style>
